const usesCentimeters = (key: string) =>
    key === 'height' || key === 'length' || key === 'offset' || key === 'width' || key === 'thickness';

export default usesCentimeters;